import { render } from "./CommunicationStatus.vue?vue&type=template&id=ce73ff20&ts=true"
import script from "./CommunicationStatus.vue?vue&type=script&lang=ts"
export * from "./CommunicationStatus.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__